import { render, staticRenderFns } from "./NavigationWallet.vue?vue&type=template&id=1028e823&scoped=true"
import script from "./NavigationWallet.vue?vue&type=script&lang=js"
export * from "./NavigationWallet.vue?vue&type=script&lang=js"
import style0 from "./NavigationWallet.vue?vue&type=style&index=0&id=1028e823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028e823",
  null
  
)

export default component.exports